<template>
  <div>
    <div class="import-text" style="margin-top: 2rem; margin-bottom: 3rem;">{{ this.$t('views.import_pbn_dictionaries.import_dictionaries_from_pbn') }}</div>
    <b-row class="d-flex align-items-center" style="margin-bottom: 1rem">
      <b-col cols="12">
        <div class="available-in" style="position: relative; top: .4rem;">
          <label style="position: relative; bottom: .1rem;">{{ this.$t('views.import_pbn_dictionaries.import_type') }}</label>
        </div>
        <pcg-select
            class="my-select-short"
            style="display: inline-block"
            :options="tDictionary(importOptions)"
            :default-option="{ text: $t('general.select'), id: '' }"
            v-model="params.importType"
        />
      </b-col>
    </b-row>
    <b-row class="d-flex align-items-center" style="margin-bottom: 1rem">
      <b-col cols="6" style="margin-right: .5rem">
        <label for="username" class="my-label">{{ this.$t('views.import_pbn_dictionaries.app_id') }}</label>
        <pcg-text-input id="username" v-model="params.appId" :showLabel="false" :showInfo="false" :showError="false" :placeholder="this.$t('views.import_pbn_dictionaries.app_id')" />
      </b-col>
    </b-row>
    <b-row class="d-flex align-items-center" style="margin-bottom: 1rem">
      <b-col cols="6" style="margin-right: .5rem">
        <label for="password" class="my-label">{{ this.$t('views.import_pbn_dictionaries.app_token') }}</label>
        <pcg-text-input id="password" v-model="params.appToken" type="password" :showLabel="false" :showInfo="false" :showError="false" :placeholder="this.$t('views.import_pbn_dictionaries.app_token')" />
      </b-col>
    </b-row>
    <b-row>
      <pcg-btn size="small" class="import-btn" @click="importDictionaries" :disabled="dictionarySpinner">
        <span>{{ this.$t('views.import_pbn_dictionaries.import') }}</span>
        <spinner v-if="dictionarySpinner"/>
      </pcg-btn>
    </b-row>
  </div>
</template>

<script>
import ApiPbn from '../../api/pbn'
import setTitle from '../../mixins/set_title'
import waitForJobs from '../../mixins/wait_for_jobs'
import Spinner from '../../components/Spinner'
import translateDictionary from '../../mixins/translate_dictionary'

export default {
  name: 'ImportPbnDictionaries',
  mixins: [setTitle, waitForJobs, translateDictionary],
  components: { Spinner },
  data () {
    return {
      headerTitle: 'views.import_pbn_dictionaries.title',
      headerSubtitle: '',
      params: {
        appId: null,
        appToken: null,
        importType: null
      },
      dictionarySpinner: false,
      importOptions: [
        { text: 'Czasopisma', text_en: 'Periodicals', id: 'periodical' },
        { text: 'Konferencje', text_en: 'Conference', id: 'conference' },
        { text: 'Wydawnictwa', text_en: 'Publishers', id: 'publisher' }
      ]
    }
  },
  mounted () {
    window.scrollTo({ left: 0, top: 0, behavior: 'smooth' })
    this.$store.dispatch('header/setHeader', {
      title: this.$t(this.headerTitle),
      subtitle: this.$t(this.headerSubtitle),
      capitalizeSubtitle: false
    })
  },
  methods: {
    importDictionaries () {
      if (!this.params.appId || !this.params.appToken || !this.params.importType) {
        this.$toastr.i('Nie wypełniono wszystkich parametrów')
      } else {
        ApiPbn.importPbnDictionaries(this.params)
            .then((result) => {
              const jobId = result.data.jobId
              if (jobId !== undefined) {
                this.dictionarySpinner = true
                this.waitForJob(jobId, this.dictionarySuccess, this.dictionaryFailure)
              }
            })
      }
    },
    dictionarySuccess () {
      this.dictionarySpinner = false
      this.$toastr.s('Import przebiegł pomyślnie')
    },
    dictionaryFailure () {
      this.dictionarySpinner = false
      this.$toastr.e('Podczas importu wystąpił błąd')
    }
  }
}
</script>

<style scoped lang="scss">
@import '../../assets/stylesheets/vars';

.import-btn {
  position: relative;
  top: .3rem;
}

.import-text {
  color: $pcg-gray;
  font-weight: 400;
  font-size: $font-size-m;
}

.my-label {
  color: $pcg-gray;
  font-weight: 400;
}

.available-in {
  font-size: 1em;
  color: $pcg-gray;
  font-weight: 400;
  margin-right: 1.5rem;
  display: inline;
  float: left;
}

.my-select-short {
  margin-right: .8rem;
  margin-left: .7rem;
  width: 200px;
  position: relative;
  display: inline-block;
  /deep/ .bootstrap-select .dropdown-toggle {
    height: calc(1.5em + 0.75em + 2px);
    color: $pcg-gray;
  }
  /deep/ .filter-option-inner {
    position: relative;
    bottom: .45rem;
  }
}
</style>

<style lang="scss">
@import "../../assets/stylesheets/vars-contrast";
.contrast {
  .import-text {
    color: $pcg-gray;
  }
  .my-label {
    color: $pcg-gray;
  }
  .available-in {
    color: $pcg-gray;
  }
  .my-select-short {
    /deep/ .bootstrap-select .dropdown-toggle {
      color: $pcg-gray;
    }
  }
}
</style>